/* Hovi: Shopify consent -> Google Consent Mode and Rolex V7. Meta is managed by Shopify's app pixel.
 * No legacy consent reads. No queued interaction replay. No manual pageView direct call.
 */
(function () {
  'use strict';
  if (window.HoviConsent) return;
  var state = { analytics: false, marketing: false, preferences: false };
  var apiReady = false, featureRequested = false, launchRequested = false, launchReady = false;
  var legacyFeatureRequested = false;
  var iframeState = null, successfulFormTracked = false;
  var smartClockMount = null;
  var launchUrl = document.documentElement.dataset.hoviRolexLaunchUrl ||
    'https://assets.adobedtm.com/7e3b3fa0902e/7ba12da1470f/launch-73c56043319a-staging.min.js';
  var iframeOrigin = 'https://cornersv7.rolex.com';

  function cookie(name, value) {
    document.cookie = name + '=' + (value ? 'true' : 'false') + '; path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }
  function iframe() { return document.getElementById('rlx-corner'); }
  function post(frame, message) { frame.contentWindow.postMessage(message, iframeOrigin); }
  function syncIframe(changed) {
    var frame = iframe();
    if (!frame || !frame.contentWindow) return;
    // The synchronous bootstrap deliberately initializes false before retailer.js.
    // Restore an existing explicit Shopify choice once as well as handling changes.
    var previous = iframeState && iframeState.frame === frame ? iframeState : { analytics: false, marketing: false };
    var accepted = false;
    if (previous.analytics !== state.analytics) {
      post(frame, state.analytics ? 'consentTrue' : 'consentFalse');
      accepted = accepted || state.analytics;
    }
    if (previous.marketing !== state.marketing) {
      post(frame, state.marketing ? 'marketingTrue' : 'marketingFalse');
      accepted = accepted || state.marketing;
    }
    if (accepted) post(frame, 'consentValidation');
    iframeState = { frame: frame, analytics: state.analytics, marketing: state.marketing };
  }
  function isRolexHtml() {
    return document.documentElement.dataset.hoviRolexTracking === 'html' && !iframe();
  }
  function track(name) {
    if (!state.analytics || !isRolexHtml() || !launchReady || !window._satellite ||
        typeof window._satellite.track !== 'function') return false;
    window._satellite.track(name);
    return true;
  }
  function trackSuccessfulForm() {
    if (successfulFormTracked || !document.querySelector('[data-hovi-rolex-contact-success]')) return;
    var key = 'hovi-rolex-contact-success:' + location.pathname;
    // A confirmation URL alone is not proof of a submitted message.
    // Reuse the existing per-tab deduplication key; never store form fields.
    var proof;
    try { proof = sessionStorage.getItem(key); } catch (_) { return; }
    if (!proof || proof.indexOf('pending:') !== 0) return;
    var age = Date.now() - Number(proof.slice(8));
    if (!Number.isFinite(age) || age < 0 || age > 60 * 60 * 1000) {
      try { sessionStorage.removeItem(key); } catch (_) {}
      return;
    }
    if (track('contactForm')) {
      successfulFormTracked = true;
      try { sessionStorage.setItem(key, 'sent'); } catch (_) {}
    }
  }
  function loadLaunch() {
    if (!state.analytics || !isRolexHtml() || !window.digitalDataLayer || launchRequested) return;
    launchRequested = true;
    var script = document.createElement('script');
    script.src = launchUrl;
    script.onload = function () { launchReady = true; trackSuccessfulForm(); };
    script.onerror = function () { launchRequested = false; };
    document.head.appendChild(script);
    // Rolex Launch owns the page-load hit. Do not also call track('pageView').
  }
  function syncSmartClock() {
    if (!document.querySelectorAll) return;
    var root = document.querySelector('[data-hovi-rolex-smart-clock]');
    if (!root) return;
    var mount = root.querySelector('[data-hovi-smart-clock-mount]');
    var fallback = root.querySelector('[data-hovi-smart-clock-fallback]');
    if (!mount || !fallback) return;
    if (!state.analytics) {
      smartClockMount = null;
      mount.replaceChildren();
      mount.hidden = true; fallback.hidden = false;
      delete window.rlxSmrtClck;
      return;
    }
    if (smartClockMount === mount) return;
    smartClockMount = mount;
    var marker = document.createElement('script');
    marker.id = 'rlxSmartClock'; marker.async = true;
    marker.src = 'https://clock.rolex.com/smart-clock/static/js/invoker.js';
    window.rlxSmrtClck = function (api) {
      delete window.rlxSmrtClck;
      // Consent can be withdrawn while the external script is still loading.
      if (!state.analytics || smartClockMount !== mount || !marker.isConnected) return;
      try {
        api.create(marker, [root.dataset.hoviClockKey, 'fi',
          'https://hovisepat.fi/collections/rolex/?cmplp=contact', 'richleft', 'light', 'gold']);
        mount.hidden = false; fallback.hidden = true;
      } catch (_) { smartClockMount = null; }
    };
    marker.onerror = function () { smartClockMount = null; delete window.rlxSmrtClck; };
    mount.appendChild(marker);
  }
  function sync(changed) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var consent;
    try {
      consent = privacy.currentVisitorConsent();
      // Explicit yes AND processing permission. Regional defaults alone never opt into Rolex.
      state = {
        analytics: consent.analytics === 'yes' && privacy.analyticsProcessingAllowed(),
        marketing: consent.marketing === 'yes' && privacy.marketingAllowed(),
        preferences: consent.preferences === 'yes' && privacy.preferencesProcessingAllowed()
      };
    } catch (_) { state = { analytics: false, marketing: false, preferences: false }; }
    cookie('rlx-consent', state.analytics);
    cookie('rlx-marketing', state.marketing);
    window.gtag('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: state.marketing ? 'granted' : 'denied',
      ad_user_data: state.marketing ? 'granted' : 'denied',
      ad_personalization: state.marketing ? 'granted' : 'denied',
      functionality_storage: state.preferences ? 'granted' : 'denied',
      personalization_storage: state.preferences ? 'granted' : 'denied', security_storage: 'granted'
    });
    syncIframe(changed);
    syncSmartClock();
    loadLaunch();
    trackSuccessfulForm();
  }
  function requestPrivacyAPI(version) {
    if (apiReady) return;
    if (version === '0.1') {
      if (legacyFeatureRequested) return;
      legacyFeatureRequested = true;
    }
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: version }], function (error) {
        if (!error && window.Shopify.customerPrivacy) {
          if (!apiReady) { apiReady = true; sync(false); }
        } else if (version === '0.2') requestPrivacyAPI('0.1');
      });
    } catch (_) {
      if (version === '0.2') requestPrivacyAPI('0.1');
    }
    // Some storefront loaders warn without invoking the callback on a failed load.
    if (version === '0.2') setTimeout(function () {
      if (!apiReady) {
        if (window.Shopify.customerPrivacy) { apiReady = true; sync(false); }
        else requestPrivacyAPI('0.1');
      }
    }, 3000);
  }
  function initialize() {
    if (apiReady) return;
    if (window.Shopify && window.Shopify.customerPrivacy) { apiReady = true; sync(false); return; }
    if (!featureRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      featureRequested = true;
      requestPrivacyAPI('0.2');
    }
  }
  document.addEventListener('visitorConsentCollected', function () { sync(true); });
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-hovi-cookie-preferences]');
    if (link) {
      // Leave the explanatory policy link usable if the native banner is unavailable.
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        event.preventDefault(); window.privacyBanner.showPreferences();
      }
      return;
    }
    var target = event.target.closest && event.target.closest('[data-hovi-rolex-event]');
    if (target) track(target.dataset.hoviRolexEvent);
  });
  document.addEventListener('submit', function (event) {
    if (!event.target.matches || !event.target.matches('[data-hovi-rolex-contact-form]')) return;
    if (typeof event.target.checkValidity === 'function' && !event.target.checkValidity()) return;
    var key = 'hovi-rolex-contact-success:' + location.pathname;
    try {
      sessionStorage.removeItem(key);
      // No conversion replay if analytics was denied when the message was submitted.
      if (state.analytics) sessionStorage.setItem(key, 'pending:' + Date.now());
    } catch (_) {}
  });
  window.HoviConsent = { trackRolex: track };
  initialize();
  window.addEventListener('load', initialize, { once: true });
})();

/* Hovi: Finnish cookie disclosures inside Shopify's native preferences dialog.
 * Information only: never read or write consent, cookies or tracking state here.
 * Update this inventory when providers or their cookie settings change.
 */
(function () {
  'use strict';
  if (typeof MutationObserver !== 'function' || window.HoviCookieDisclosure) return;
  if (!/^fi(?:-|$)/i.test(document.documentElement.lang || 'fi')) return;
  window.HoviCookieDisclosure = true;
  var sections = {
    essential: {
      overview: 'Hovisepät ja Shopify: ostoskori, turvallinen asiointi, aluevalinnat ja evästevalintasi muistaminen. Nämä toiminnot eivät anna lupaa analytiikkaan tai markkinointiin.',
      rows: [
        ['_shopify_essential', 'Shopify · enintään 1 vuosi', 'Ylläpitää kaupan istuntoa ja kassatoimintoja sekä suojaa tietojen luvattomalta muuttamiselta.'],
        ['cart, cart_currency', 'Shopify · enintään 14 päivää', 'Muistavat ostoskorin ja sen valuutan. cart syntyy ostoskoria käytettäessä.'],
        ['localization', 'Shopify · enintään 1 vuosi', 'Muistaa asiointimaan ja aluekohtaiset kaupan asetukset.'],
        ['_tracking_consent', 'Shopify · enintään 1 vuosi', 'Tallentaa valitsemasi evästeluvat silloin, kun Shopify käyttää tätä suostumusevästettä.']
      ],
      links: [['Shopifyn evästetiedot', 'https://www.shopify.com/legal/cookies']]
    },
    preferences: {
      overview: 'Muistaa valinnaisia käyttömukavuusasetuksia. Tämä lupa ei yksin salli Google Analyticsia, Meta-pikseliä tai Rolexin Adobe-analytiikkaa.',
      rows: [],
      note: 'Tässä kategoriassa ei tällä hetkellä ole erillisiä personointievästeitä. Asiointimaan ja ostoskorin toiminnan tarvitsemat asetukset on eritelty Välttämättömät-kohdassa.',
      links: []
    },
    marketing: {
      overview: 'Google, Meta ja Shopify: mainonnan kohdentaminen sekä mainosten kautta syntyvien käyntien ja ostosten mittaaminen. Tämä valinta ohjaa myös Rolex-sisällön markkinointisuostumusta.',
      rows: [
        ['_gcl_au, _gcl_*', 'Google · enintään 90 päivää', 'Yhdistävät mainosklikkauksia sivuston toimintoihin ja ostoksiin mainonnan tulosten mittaamiseksi. Klikkaustunnisteita syntyy myös saapumislinkin perusteella.'],
        ['_fbp', 'Meta · enintään 90 päivää', 'Tunnistaa selaimen Meta-pikselin tapahtumissa mainonnan mittaamista ja kohdentamista varten.'],
        ['_fbc', 'Meta · enintään 90 päivää', 'Tallentaa Meta-mainoksen klikkaustunnisteen, jos saavut mainoslinkistä, jossa on fbclid-tunniste.'],
        ['_shopify_marketing', 'Shopify · enintään 1 vuosi', 'Tallentaa kaupan ja kassan markkinointiin liittyviä tunnisteita ja tapahtumatietoja.'],
        ['rlx-marketing', 'Hovisepät / Rolex · selainistunto', 'Välittää tämän kategorian valinnan Rolex-sisällölle: true, kun hyväksyt markkinoinnin, ja false, kun et hyväksy sitä. Tekninen suostumustieto asetetaan myös hylkäyksen yhteydessä; se ei itsessään tunnista kävijää tai käynnistä analytiikkaa.']
      ],
      note: 'Vastaanottajia ovat Google Ireland Limited, Meta Platforms Ireland Limited ja Shopify. Tapahtumat voivat sisältää sivun osoitteen, tuote- ja tapahtumatunnisteita, ostoksen arvon ja valuutan sekä selain-, laite- ja IP-tietoja. Nykyisessä Shopify–Meta-toteutuksessa pikseli käynnistyy vasta, kun sekä Markkinointi että Analytiikka on hyväksytty. Rolex-sisällölle välitetään myös markkinointivalintasi.',
      links: [['Googlen evästetiedot', 'https://policies.google.com/technologies/cookies'], ['Metan evästetiedot', 'https://www.facebook.com/privacy/policies/cookies/'], ['Shopifyn evästetiedot', 'https://www.shopify.com/legal/cookies'], ['Rolexin evästetiedot', 'https://www.rolex.com/legal-notices/cookies']]
    },
    analytics: {
      overview: 'Google Analytics, Shopify ja Rolex / Adobe Analytics: käyntien, sivujen käytön, tuotteisiin tutustumisen ja verkkokaupan tapahtumien mittaaminen.',
      rows: [
        ['_ga', 'Google Analytics · oletuskesto enintään 2 vuotta', 'Erottaa saman selaimen käynnit muiden selainten käynneistä.'],
        ['_ga_LJWFVJJ5WG, _ga_KKMXXK9VNX, _ga_PL3G3M5R4S', 'Google · oletuskesto enintään 2 vuotta', 'Säilyttävät Google-tunnisteiden istuntotietoja, kuten käyntien ajankohtia ja istuntojen tunnisteita.'],
        ['_shopify_analytics, _shopify_y', 'Shopify · enintään 1 vuosi', 'Kaupan ja kassan käyttöä sekä palaavia käyntejä koskeva analytiikka.'],
        ['_shopify_s', 'Shopify · 30 minuuttia viimeisestä käytöstä', 'Yhdistää tapahtumat samaan selainistuntoon. Shopify-versio voi käyttää erillisten tunnisteiden sijaan _shopify_analytics-evästettä.'],
        ['rlx-consent', 'Hovisepät / Rolex · selainistunto', 'Välittää tämän kategorian valinnan Rolex-sisällön tilastolliselle seurannalle: true, kun hyväksyt analytiikan, ja false, kun et hyväksy sitä. Tekninen suostumustieto asetetaan myös hylkäyksen yhteydessä; se ei itsessään tunnista kävijää.'],
        ['ai_session (clock.rolex.com)', 'Rolexin ulkoinen kellopalvelu · noin 1 tunti', 'Kellopalvelun oma istuntotunniste käytön ja teknisen toiminnan mittaamiseen.'],
        ['ai_user (clock.rolex.com)', 'Rolexin ulkoinen kellopalvelu · enintään 1 vuosi', 'Kellopalvelun oma kävijätunniste käytön mittaamiseen.'],
        ['hovi-rolex-contact-success:*', 'Hovisepät · välilehden istunto (sessionStorage)', 'Estää saman onnistuneen Rolex-yhteydenoton laskemisen kahdesti. Ei sisällä lomakkeen yhteystietoja.']
      ],
      service: 'Rolex / Adobe Analytics: Rolex SA käyttää Adobe Analyticsia Rolex-osion käytön tilastolliseen mittaamiseen. Mittaus koskee esimerkiksi katsottuja sivuja ja kellomallistoja sekä yhteydenottotoimintojen käyttöä. Tämä seuranta edellyttää Analytiikka-valinnan hyväksymistä; Markkinointi-valinta ei yksin salli sitä. Rolexin palvelussa käytettävien muiden tunnisteiden ja evästeiden tiedot ovat Rolexin evästekäytännössä.',
      note: 'Googlelle ja Shopifylle välittyy käynti- ja tapahtumatietoja sekä selain-, laite- ja IP-tietoja. Rolex-osion mittaustietoja välitetään Rolex SA:lle ja sen Adobe-analytiikkapalveluun. Ulkoinen kellopalvelu toimii clock.rolex.com-verkkotunnuksessa ja on erillinen Rolex-osion Adobe-mittauksesta. Kaikkia lueteltuja evästeitä ei aseteta jokaiselle käynnille. Istunto tarkoittaa selaimen tai välilehden käyttöjaksoa; selain voi palauttaa istuntoja ja lyhentää ilmoitettuja enimmäiskestoja.',
      links: [['Google Analyticsin evästetiedot', 'https://support.google.com/analytics/answer/11397207?hl=fi'], ['Rolexin evästetiedot', 'https://www.rolex.com/legal-notices/cookies'], ['Adoben evästetiedot', 'https://experienceleague.adobe.com/en/docs/core-services/interface/data-collection/cookies/analytics']]
    }
  };
  function element(tag, text, className) {
    var node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function enhance() {
    var dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (!dialog) return;
    Object.keys(sections).forEach(function (key) {
      var target = dialog.querySelector('#shopify-pc__prefs__' + key);
      if (!target || target.querySelector('[data-hovi-cookie-disclosure]')) return;
      var section = sections[key];
      var block = element('div', '', 'hovi-cookie-disclosure');
      block.setAttribute('data-hovi-cookie-disclosure', key);
      block.appendChild(element('p', section.overview, 'hovi-cookie-overview'));
      var details = element('details');
      details.appendChild(element('summary', 'Evästeet, käyttötarkoitukset ja säilytysajat'));
      if (section.service) details.appendChild(element('p', section.service));
      if (section.rows.length) {
        var list = element('dl');
        section.rows.forEach(function (row) {
          list.appendChild(element('dt', row[0]));
          var description = element('dd');
          description.appendChild(element('span', row[1], 'hovi-cookie-duration'));
          description.appendChild(element('span', row[2]));
          list.appendChild(description);
        });
        details.appendChild(list);
      }
      var categoryInfo = element('div', '', 'hovi-cookie-category-info');
      var categoryTitle = element('p');
      categoryTitle.appendChild(element('strong', 'Koko kategoriaa koskevat tiedot'));
      categoryInfo.appendChild(categoryTitle);
      if (section.note) categoryInfo.appendChild(element('p', section.note));
      var links = element('p', '', 'hovi-cookie-links');
      section.links.forEach(function (item) {
        var link = element('a', item[0]);
        link.href = item[1]; link.target = '_blank'; link.rel = 'noopener noreferrer';
        links.appendChild(link);
      });
      if (section.links.length) categoryInfo.appendChild(links);
      if (section.note || section.links.length) details.appendChild(categoryInfo);
      block.appendChild(details);
      target.appendChild(block);
    });
    var intro = dialog.querySelector('.shopify-pc__prefs__intro-main');
    if (intro && !intro.querySelector('[data-hovi-cookie-information]')) {
      var info = element('p', 'Voit muuttaa tai perua valintasi milloin tahansa sivun alareunan Evästeasetukset-linkistä. Hylkääminen ei välttämättä poista aiemmin tallennettuja evästeitä selaimestasi. ');
      info.setAttribute('data-hovi-cookie-information', '');
      var policy = element('a', 'Tietosuojakäytäntö');
      policy.href = '/policies/privacy-policy'; policy.target = '_blank'; policy.rel = 'noopener noreferrer';
      info.appendChild(policy); intro.appendChild(info);
    }
  }
  var style = element('style');
  style.id = 'hovi-cookie-disclosure-style';
  style.textContent = '#shopify-pc__prefs__dialog .hovi-cookie-disclosure{margin:.6rem 0 1rem 2.75rem;overflow-wrap:anywhere}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure p{margin:.5rem 0!important;padding:0!important;font-size:14px;line-height:1.6}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure details{margin-top:.5rem}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure summary{cursor:pointer;text-decoration:underline;text-underline-offset:3px;font-size:14px;padding:.35rem 0}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure summary::before{content:"+ ";font-weight:600}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure details[open]>summary::before{content:"− ";font-weight:600}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure summary:focus-visible{outline:2px solid currentColor;outline-offset:3px}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure dl{margin:.5rem 0;font-size:14px;line-height:1.6}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure dt{font-weight:600;border-top:1px solid #ddd;padding-top:.6rem;margin-top:.6rem}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure dd{margin:0 0 .6rem}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-disclosure dd span{display:block}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-duration{font-weight:500}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-category-info{margin-top:1rem;border-top:1px solid #bbb;padding-top:.5rem}' +
    '#shopify-pc__prefs__dialog .hovi-cookie-links a{display:inline-block;margin:.25rem 1rem .25rem 0;text-decoration:underline}' +
    '#shopify-pc__prefs__dialog [data-hovi-cookie-information]{font-size:14px;line-height:1.6}' +
    '#shopify-pc__prefs__dialog [data-hovi-cookie-information] a{text-decoration:underline}' +
    '@media(max-width:600px){#shopify-pc__prefs__dialog .hovi-cookie-disclosure{margin-left:0}}';
  document.head.appendChild(style);
  enhance();
  // Observe only child insertion/removal. Our additions are idempotent and do not
  // observe attributes, native checkbox changes or details open/close toggles.
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 && (node.id === 'shopify-pc__prefs__dialog' ||
          (node.querySelector && node.querySelector('#shopify-pc__prefs__dialog')));
      });
    })) enhance();
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
